export default "__VITE_ASSET__UNwxapvB__"